import { deleteDocumentTemplateMutation, documentTemplateInfoByDocumentIdQuery } from "@affine/graphql";

export const deleteTemplate  = (documentId, workspaceId,graphqlService ) => {
  graphqlService.gql({
    query: documentTemplateInfoByDocumentIdQuery,
    variables: {
      documentId,
      workspaceId
    }
  }).then(res => {
    const data = res.documentTemplatesByDocumentId
    if (data.isTemplate) {
      // 模板文档，需要删除
      graphqlService.gql({
        query: deleteDocumentTemplateMutation,
        variables: {
          id: data.templateId,
        }
      })
    }
  })
}

export function generateUniqueTitle(
  existingTitles: string[],
  newTitle?: string
): string {
  const titleSet = new Set(existingTitles);
  // 如果标题不存在或为空字符串，使用“未命名”
  const baseTitle = newTitle && newTitle.trim() ? newTitle : "未命名";
  // 如果不存在，直接返回
  if (!titleSet.has(baseTitle)) {
    return baseTitle;
  }
  let index = 1;
  let candidate = `${baseTitle}(${index})`;
  // 循环查找不重复的标题
  while (titleSet.has(candidate)) {
    index += 1;
    candidate = `${baseTitle}(${index})`;
  }
  return candidate;
}
